module.exports = __webpack_public_path__ + "static/media/vimeo.8534c363.svg";